/**
 * @desc 保存
 */
const URL = "/rantion-business";
import http, { updateResponse } from "@/http";
export function request(body: defs.business.CustomerOrderRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/customerOrder/saveOrder`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
